import React from 'react';
import CommonFeature from '../common/Feature';

const Feature = ({ feature }) => {
	return (
		<CommonFeature
			title={ feature.name }
			description={ feature.description }
			image={ feature.image }
		/>
	);
};

export default Feature;


// WEBPACK FOOTER //
// ./src/pages/product/Feature.js